import React from "react";
import Lookup from "../../Components/Attributes/AttributeTemplate/Lookup";

const WorkspacePropertyTemplatesPage = ({ organization, user, role }) => {
    return (
        <Lookup
            organization={organization}
            showInIframe={true}
        />
    );
};

export default WorkspacePropertyTemplatesPage; 